export const countries = {
  gp: {
    description:
      "The butterfly island offering rich Creole culture and the Soufrière volcano.",
    landmarks: ["La Soufrière Volcano", "Grande Anse Beach", "Carbet Falls"],
    gastronomy: "Cod fritters (accras), chicken colombo, tourment d'amour.",
  },
  mq: {
    description:
      "The mesmerizing Island of Flowers, renowned for Mount Pelée and agricultural rum.",
    landmarks: ["Mount Pelée", "Balata Garden", "Diamond Rock"],
    gastronomy: "Smoked chicken, Creole boudin, coconut blanc-manger.",
  },
  gf: {
    description:
      "Europe's gateway to space and a sanctuary for rich Amazonian biodiversity.",
    landmarks: ["Guiana Space Centre", "Salvation Islands", "Kaw Marshes"],
    gastronomy: "Awara broth, wild game fricassee, roasted chicken.",
  },
  re: {
    description:
      "A volcanic jewel of the Indian Ocean combining turquoise lagoons and steep cirques.",
    landmarks: ["Piton de la Fournaise", "Mafate Cirque", "Piton des Neiges"],
    gastronomy: "Sausage rougail, chicken curry, samosas.",
  },
  yt: {
    description:
      "The perfume island circled by a massive lagoon sheltering majestic sea turtles.",
    landmarks: ["Mayotte Lagoon", "Mount Choungui", "N'Gouja Beach"],
    gastronomy: "Zebu skewers, mataba (cassava leaves), pilao rice.",
  },
  pf: {
    description:
      "Earth's paradise in the Pacific, dotted with overwater bungalows and coral reefs.",
    landmarks: ["Bora Bora Lagoon", "Mount Otemanu", "Cook's Bay"],
    gastronomy: "Raw fish in coconut milk, fafaru, poe dessert.",
  },
  nc: {
    description:
      "A land of contrasts, featuring the world's largest enclosed lagoon and Kanak culture.",
    landmarks: ["Amédée Lighthouse", "Heart of Voh", "Oro Bay"],
    gastronomy: "Traditional Bougna, venison salad, ceviche.",
  },
  ic: {
    description:
      "An archipelago of eternal spring, sculpted by lunar volcanic landscapes.",
    landmarks: ["Teide National Park", "Maspalomas Dunes", "Timanfaya"],
    gastronomy: "Papas arrugadas, mojo sauce, sancocho fish stew.",
  },
  ptm: {
    description:
      "The island of eternal spring plunging dramatically into the Atlantic with its gardens.",
    landmarks: ["Pico do Arieiro", "Cabo Girão", "Levadas Trails"],
    gastronomy: "Espetada, bolo do caco bread, black scabbardfish.",
  },
  pta: {
    description:
      "A pristine oceanic sanctuary where volcanic craters form stunning twin lakes.",
    landmarks: ["Sete Cidades Twin Lakes", "Mount Pico", "Furnas Springs"],
    gastronomy: "Cozido das Furnas (volcanic stew), São Jorge cheese.",
  },
  aw: {
    description:
      "Cooling trade winds sweep across long stretches of powdery white sand on this colorful island.",
    landmarks: ["Arikok National Park", "Eagle Beach", "California Lighthouse"],
    gastronomy: "Keshi Yena, pastechi pastries, goat stew.",
  },
  cw: {
    description:
      "Famous for its hidden crystal-water coves and pastel Dutch architecture.",
    landmarks: ["Queen Emma Bridge", "Playa Porto Mari", "Christoffel Park"],
    gastronomy: "Karni stoba beef stew, pumpkin pancakes.",
  },
  sx: {
    description:
      "The Friendly Island, charming with airplanes skimming its beach and spectacular gastronomy.",
    landmarks: ["Maho Beach", "Pic Paradis", "Orient Bay"],
    gastronomy: "BBQ ribs, journey cakes, stuffed crab back.",
  },
  bm: {
    description:
      "A mythical archipelago lined with elegant rivieras and beautiful pink sand beaches.",
    landmarks: [
      "Horseshoe Bay Beach",
      "Crystal Caves",
      "Gibbs Hill Lighthouse",
    ],
    gastronomy: "Bermuda Fish Chowder, hoppin' john.",
  },
  ky: {
    description:
      "The world's scuba diving paradise offering aquatic ballets with friendly stingrays.",
    landmarks: ["Stingray City", "Seven Mile Beach", "Botanic Park"],
    gastronomy: "Cayman style beef, conch fritters, heavy cassava cake.",
  },

  fr: {
    description:
      "France is the world's top tourist destination, renowned for its exceptional heritage, diverse landscapes ranging from the French Riviera to the Alpine peaks, and an incomparable art de vivre.",
    gastronomy: "Baguette, cheeses, wine, croissants, beef bourguignon.",
    landmarks: [
      "Eiffel Tower, Paris",
      "Mont Saint-Michel",
      "Loire Valley Castles",
      "French Riviera",
    ],
    overseas: [
      "Guadeloupe",
      "Martinique",
      "French Guiana",
      "Réunion",
      "Mayotte",
      "French Polynesia",
      "New Caledonia",
    ],
  },
  es: {
    description:
      "Spain mesmerizes with its sunny climate, vibrant culture from siestas to flamenco, magnificent beaches, and unique historical architecture, especially its Moorish heritage.",
    gastronomy: "Tapas, paella, Iberian ham, gazpacho, sangria.",
    landmarks: [
      "Sagrada Familia, Barcelona",
      "Alhambra, Granada",
      "Royal Palace of Madrid",
      "Plaza de España, Seville",
    ],
    overseas: ["Canary Islands", "Balearic Islands", "Ceuta", "Melilla"],
  },
  it: {
    description:
      "Italy is an open-air museum. Between Roman ruins, the Florentine Renaissance, Venetian canals, and a picturesque coastline, the country offers an unforgettable journey.",
    gastronomy: "Pasta, pizza, gelato, espresso, tiramisu.",
    landmarks: [
      "Colosseum, Rome",
      "Leaning Tower of Pisa",
      "Florence Cathedral",
      "Grand Canal, Venice",
    ],
    overseas: ["Sardinia"],
  },
  de: {
    description:
      "Germany blends urban modernity with the romance of its castles and the Black Forest. Known for its dynamism and rich history.",
    gastronomy: "Bratwurst, pretzel, sauerkraut, beer.",
    landmarks: [
      "Brandenburg Gate, Berlin",
      "Neuschwanstein Castle",
      "Cologne Cathedral",
      "Marienplatz, Munich",
    ],
  },
  gb: {
    description:
      "The United Kingdom offers a unique mix of monarchic tradition, cultural avant-garde, stunning Scottish landscapes, and historic cities.",
    gastronomy: "Fish and chips, roast beef, Yorkshire pudding, tea.",
    landmarks: [
      "Big Ben and Westminster Palace",
      "Stonehenge",
      "Tower of London",
      "Edinburgh Castle",
    ],
    overseas: ["Bermuda", "Cayman Islands", "Gibraltar"],
  },
  pt: {
    description:
      "Portugal enchants with its colorful streets, Atlantic-washed beaches, and the exceptional hospitality of its people, set to the haunting melody of Fado.",
    gastronomy: "Pastéis de nata, bacalhau, Francesinha, Port wine.",
    landmarks: [
      "Belém Tower, Lisbon",
      "Ribeira, Porto",
      "Pena Palace, Sintra",
      "Algarve beaches",
    ],
    overseas: ["Madeira", "Azores"],
  },
  gr: {
    description:
      "Cradle of Western civilization, Greece invites you on a mythological journey, from the Acropolis to the sublime crystal-clear waters of the Cyclades islands.",
    gastronomy: "Moussaka, souvlaki, Greek salad, tzatziki.",
    landmarks: [
      "Acropolis of Athens",
      "Santorini",
      "Meteora",
      "Knossos Palace",
    ],
    overseas: ["Crete", "Rhodes"],
  },
  ch: {
    description:
      "Switzerland is an alpine paradise offering deep blue lakes, medieval fortresses, and staggering mountains, perfect for nature and comfort lovers alike.",
    gastronomy: "Cheese fondue, raclette, Swiss chocolate, rösti.",
    landmarks: ["Matterhorn", "Lake Geneva", "Chillon Castle", "Jungfraujoch"],
  },
  nl: {
    description:
      "The Netherlands are famous for their flat landscapes, labyrinthine canals, tulip fields, and iconic windmills.",
    gastronomy: "Gouda, stroopwafel, raw herring, poffertjes.",
    landmarks: [
      "Amsterdam Canals",
      "Keukenhof Gardens",
      "Kinderdijk Windmills",
      "Van Gogh Museum",
    ],
    overseas: ["Aruba", "Curaçao"],
  },
  be: {
    description:
      "At the heart of Europe, Belgium is world-renowned for its enchanting medieval towns, European diplomacy, its chocolate and beer.",
    gastronomy: "Waffles, fries, mussels, pralines, trappist beers.",
    landmarks: [
      "Grand Place of Brussels",
      "Belfry of Bruges",
      "Atomium",
      "Gravensteen Castle",
    ],
  },
  bg: {
    description:
      "Bulgaria is a Balkan mosaic combining golden Black Sea coasts, mountainous terrains, and an incredible Thracian heritage.",
    gastronomy: "Banitsa, Shopska salad, tarator, Bulgarian moussaka.",
    landmarks: ["Rila Monastery", "Alexander Nevsky Cathedral", "Sunny Beach"],
  },
  dk: {
    description:
      "Denmark represents the concept of 'Hygge': a peaceful Nordic country, a pioneer in design, full of bike paths and royal palaces.",
    gastronomy: "Smørrebrød, frikadeller, Wienerbrød, Carlsberg beer.",
    landmarks: [
      "Tivoli Gardens",
      "Nyhavn",
      "The Little Mermaid",
      "Kronborg Castle",
    ],
    overseas: ["Faroe Islands", "Greenland"],
  },
  hr: {
    description:
      "Croatia offers over a thousand islands along the Adriatic Sea, dotted with Roman architectural gems and lush national parks.",
    gastronomy: "Ćevapi, octopus salad, peka, Pag island cheeses.",
    landmarks: [
      "Walls of Dubrovnik",
      "Plitvice Lakes National Park",
      "Diocletian's Palace",
    ],
  },
  cy: {
    description:
      "Cyprus is a legendary Mediterranean island, the birthplace of Aphrodite, combining pristine beaches with impressive ancient ruins.",
    gastronomy: "Halloumi, souvla, sheftalia, moussaka.",
    landmarks: [
      "Paphos Archaeological Park",
      "Aphrodite's Rock",
      "Troodos Mountains",
    ],
  },
  cz: {
    description:
      "Czechia fascinates with its cities of a hundred spires, centuries-old breweries, and fairytale castles in the heart of Central Europe.",
    gastronomy: "Goulash, Trdelník, Vepřo knedlo zelo, Pilsner.",
    landmarks: [
      "Charles Bridge, Prague",
      "Prague Castle",
      "Sedlec Ossuary",
      "Karlovy Vary",
    ],
  },
  ee: {
    description:
      "Estonia is a digital pioneer nation home to vast primeval forests and an intact medieval capital facing the Baltic.",
    gastronomy: "Verivorst (blood sausage), black bread, sprats, craft beer.",
    landmarks: ["Tallinn Old Town", "Lahemaa National Park", "Hermann Castle"],
  },
  fi: {
    description:
      "Finland, the country of a thousand lakes, is famous for its shimmering wilderness, the Northern Lights in Lapland, and its vital sauna culture.",
    gastronomy: "Smoked salmon, reindeer meat, rye bread, Karelian pasties.",
    landmarks: ["Suomenlinna", "Santa Claus Village", "Nuuksio National Park"],
  },
  hu: {
    description:
      "Hungary is beautifully bisected by the Danube, teeming with spectacular thermal baths, historic vineyards, and the majestic parliament.",
    gastronomy: "Goulash, Lángos, Chicken Paprikash, Tokaji wine.",
    landmarks: [
      "Budapest Parliament",
      "Széchenyi Thermal Bath",
      "Buda Castle",
      "Lake Balaton",
    ],
  },
  ie: {
    description:
      "Ireland, the Emerald Isle, is defined by its windswept cliffs, warm Celtic music, and welcoming pub culture.",
    gastronomy: "Irish stew, Guinness, soda bread, colcannon.",
    landmarks: [
      "Cliffs of Moher",
      "Guinness Storehouse",
      "Ring of Kerry",
      "Trinity College",
    ],
  },
  lv: {
    description:
      "Latvia enchants with its bustling capital full of Art Nouveau architecture and miles of pristine beaches on the Baltic coast.",
    gastronomy: "Rupjmaize (dark rye bread), grey peas with bacon, sprats.",
    landmarks: [
      "Riga Old Town",
      "House of the Blackheads",
      "Gauja National Park",
    ],
  },
  lt: {
    description:
      "Lithuania is the southernmost Baltic gem, rich in glacial lakes, dense forests, and touching testaments to its tumultuous past.",
    gastronomy:
      "Cepelinai (potato dumplings), cold borscht soup (šaltibarščiai).",
    landmarks: ["Trakai Island Castle", "Hill of Crosses", "Vilnius Old Town"],
  },
  lu: {
    description:
      "Luxembourg is a prosperous grand ducal microstate, whose valleys brim with medieval castles and capital is a spectacular citadel.",
    gastronomy: "Judd mat Gaardebounen, Gromperekichelcher, Moselle wines.",
    landmarks: ["Chemin de la Corniche", "Bock Casemates", "Vianden Castle"],
  },
  mt: {
    description:
      "Malta flawlessly combines the warmth of the Mediterranean sun and 7,000 years of naval history, Templar fortresses, and turquoise lagoons.",
    gastronomy: "Pastizzi, rabbit stew (Stuffat tal-fenek), ftira.",
    landmarks: [
      "St. John's Co-Cathedral",
      "City of Mdina",
      "Blue Lagoon (Comino)",
    ],
  },
  pl: {
    description:
      "Poland is the cultural pillar of Eastern Europe, endowed with imposing restored cities, the tragic Auschwitz memorial, and the Tatra mountains.",
    gastronomy: "Pierogi, bigos, kielbasa, Polish vodka.",
    landmarks: [
      "Krakow Market Square",
      "Wieliczka Salt Mine",
      "Auschwitz-Birkenau",
      "Wawel Castle",
    ],
  },
  ro: {
    description:
      "Dominated by the legend of Dracula, Romania hosts the sumptuous Carpathian Mountains, the majestic Danube Delta, and vibrant Transylvanian cities.",
    gastronomy: "Mici, sarmale, mămăligă, tuică.",
    landmarks: [
      "Bran Castle",
      "Peleș Castle",
      "Danube Delta",
      "Palace of the Parliament",
    ],
  },
  sk: {
    description:
      "Lesser known, Slovakia is a mountainous treasure with the highest number of castles per capita in the world, within the High Tatras.",
    gastronomy: "Bryndzové halušky (sheep cheese gnocchi), Kofola.",
    landmarks: ["Bratislava Castle", "High Tatras", "Spiš Castle"],
  },
  si: {
    description:
      "Slovenia is a small eco-paradise housing the mythical Lake Bled, colossal karst caves, and an exceptionally green capital.",
    gastronomy: "Kranjska klobasa, potica (nut roll), štrukli.",
    landmarks: [
      "Lake Bled",
      "Postojna Cave",
      "Ljubljana Castle",
      "Triglav National Park",
    ],
  },
  se: {
    description:
      "Sweden embodies Scandinavian style, spread across magnificent archipelagos, northern lights, and a rich tradition of sleek design.",
    gastronomy:
      "Meatballs (Köttbullar), fika, gravlax salmon, surströmming herring.",
    landmarks: [
      "Vasa Museum",
      "Town of Visby",
      "Gamla Stan",
      "Icehotel Jukkasjärvi",
    ],
  },
  is: {
    description:
      "Iceland, the land of fire and ice, strikes with awe with its geysers, titanic glaciers, active volcanoes, and milky hot springs.",
    gastronomy: "Hákarl (fermented shark), Skyr, Icelandic lamb.",
    landmarks: [
      "Blue Lagoon",
      "Golden Circle",
      "Gullfoss Waterfall",
      "Reynisfjara Black Sand Beach",
    ],
  },
  no: {
    description:
      "Norway offers one of the world's most beautiful geological scenes: its majestic abyssal fjords carving the sea surrounded by steep mountains.",
    gastronomy: "Salmon, rakfisk, brown cheese (Brunost), moose meat.",
    landmarks: ["Geirangerfjord", "North Cape", "Lofoten Islands", "Bryggen"],
  },
  al: {
    description:
      "Formerly hermetic, Albania is the secret gem of the Mediterranean brimming with crystalline blue waters, spectacular Alps, and Greco-Roman ruins.",
    gastronomy: "Byrek, fëgesë, seafood, baklava.",
    landmarks: ["Albanian Riviera", "Berat", "Butrint National Park"],
  },
  ad: {
    description:
      "Nestled high in the Pyrenees, this tiny principality is a true sanctuary for skiing and wild nature lovers.",
    gastronomy: "Trinxat, escudella, mountain charcuterie.",
    landmarks: ["Madriu-Perafita-Claror Valley", "Caldea", "Grandvalira"],
  },
  at: {
    description:
      "An alpine country par excellence, Austria shines with its unparalleled classical music, imperial palaces, and breathtaking alpine landscapes.",
    gastronomy: "Wiener Schnitzel, Apfelstrudel, Sachertorte, Tafelspitz.",
    landmarks: ["Schönbrunn Palace", "Hofburg", "Kitzbühel Alps"],
  },
  mc: {
    description:
      "Monaco is the epitome of glamour on the shores of the Mediterranean, featuring luxury yachts, its world-famous casino, and the legendary Formula 1 Grand Prix.",
    gastronomy: "Barbajuan, Monegasque fougasse, stocafi.",
    landmarks: [
      "Monte-Carlo Casino",
      "The Rock of Monaco",
      "Prince's Palace",
      "Port Hercules",
    ],
  },
  am: {
    description:
      "Armenia, one of the world's oldest Christian nations, offers spectacular mountainous landscapes and majestic stone monasteries perched on the edge of deep canyons.",
    gastronomy: "Khorovats (Armenian BBQ), dolma, lavash, lahmajoun.",
    landmarks: ["Khor Virap Monastery", "Temple of Garni", "Geghard Monastery"],
  },
  az: {
    description:
      "Azerbaijan, the 'Land of Fire', is a fascinating blend of ancient historical heritage and gleaming ultra-modern infrastructure on the shores of the Caspian Sea.",
    gastronomy: "Plov, dolma, piti, qutab, baklava.",
    landmarks: [
      "Flame Towers (Baku)",
      "Old City (Icherisheher)",
      "Gobustan Mud Volcanoes",
    ],
  },
  by: {
    description:
      "Belarus surprises with its preserved nature, dense pristine forests (like Bialowieza) home to bison, and medieval castles with a rich past.",
    gastronomy: "Draniki (potato pancakes), machanka, kolduny.",
    landmarks: ["Mir Castle", "Nesvizh Palace", "Brest Fortress"],
  },
  ba: {
    description:
      "A crossroads of cultures in the heart of the Balkans where East meets West. You will fall in love with the emerald rivers, rugged mountains and the famous Old Bridge of Mostar.",
    gastronomy: "Ćevapi, burek, baklava, Bosnian coffee.",
    landmarks: [
      "Stari Most (Old Bridge)",
      "Baščaršija (Sarajevo)",
      "Kravica Waterfalls",
    ],
  },
  ge: {
    description:
      "Georgia offers grandiose nature in the Caucasus mountains, fascinating ancient architecture, and the reputation of being the oldest winemaking region in the world.",
    gastronomy: "Khachapuri, khinkali (dumplings), churchkhela.",
    landmarks: [
      "Gergeti Trinity Church",
      "Tbilisi Old Town",
      "Vardzia (Cave City)",
    ],
  },
  xk: {
    description:
      "A young Balkan nation, rich in history and superb mountainous landscapes, Kosovo stands out with well-preserved historic Ottoman gems and a very welcoming population.",
    gastronomy: "Flija, burek, qebapa, Šar cheese.",
    landmarks: ["Visoki Dečani Monastery", "Old Prizren", "Rugova Canyon"],
  },
  li: {
    description:
      "One of the world's smallest nations, Liechtenstein stretches between Switzerland and Austria along the Rhine valley, dominated by its beautiful princely castle and alpine peaks.",
    gastronomy: "Käsknöpfle (cheese pasta), Ribel.",
    landmarks: [
      "Vaduz Castle",
      "Museum of Fine Arts (Kunstmuseum)",
      "Malbun Ski Resort",
    ],
  },
  md: {
    description:
      "Moldova, Eastern Europe's hidden treasure, inevitably attracts wine tourism enthusiasts with its massive underground cellars and ancestral rock-hewn monasteries.",
    gastronomy: "Mămăligă (polenta), plăcinte (stuffed pastries), sarmale.",
    landmarks: [
      "Orheiul Vechi (Cave Monastery)",
      "Cricova Wineries",
      "Mileștii Mici Cellars",
    ],
  },
  me: {
    description:
      "Despite its small size, Montenegro hides some of the Adriatic Sea's most beautiful landscapes. The Bay of Kotor meets spectacular dark mountains (the 'black mountains').",
    gastronomy:
      "Brav u Mlijeku (lamb in milk), cevapi, smoked Njeguši prosciutto.",
    landmarks: ["Bay of Kotor", "Durmitor National Park", "Sveti Stefan"],
  },
  mk: {
    description:
      "In the heart of the Balkans, North Macedonia dazzles with the incredibly clear ancient Lake Ohrid, its Orthodox heritage, and preserved national parks.",
    gastronomy: "Tavče gravče (baked beans), ajvar, pastrmajlija.",
    landmarks: ["Lake Ohrid", "Church of St. John at Kaneo", "Matka Canyon"],
  },
  sm: {
    description:
      "Perched on Mount Titano and completely landlocked by Italy, San Marino claims the title of the world's oldest republic and sovereign constitutional state.",
    gastronomy:
      "Torta Tre Monti (Three Mountains Cake), piadina, beans with pork rinds.",
    landmarks: [
      "The Three Towers (Guaita, Cesta, Montale)",
      "Basilica di San Marino",
      "Piazza della Libertà",
    ],
  },
  rs: {
    description:
      "Serbia combines the vibrant nightlife of Belgrade on the Danube, the dramatic Petrovaradin fortress, and superb hidden Orthodox monasteries.",
    gastronomy: "Cevapi, pljeskavica, kajmak, rakija (fruit brandy).",
    landmarks: [
      "Belgrade Fortress (Kalemegdan)",
      "Golubac Fortress",
      "Temple of Saint Sava",
    ],
  },
  va: {
    description:
      "The Vatican, the world's smallest sovereign state, resides in the heart of Rome serving as the spiritual seat of the Catholic Church, housing prodigious artistic masterpieces by Michelangelo.",
    gastronomy: "No exclusive cuisine; features traditional Roman gastronomy.",
    landmarks: ["St. Peter's Basilica", "Vatican Museums"],
  },
};
